import { UnifyIntentClient, UnifyIntentClientConfig } from "@unifygtm/intent-client";
import { getGlobalWindowHook } from "@/utils/window";

const UNIFY_DATA_KEY = "wk_Wwm4qdeM_2YAvx6jgzeXAD3kP1acAj4AHBcKxdQ2z";

const UNIFY_CLIENT_CONFIG = {
  autoPage: true,
  autoIdentify: false,
} satisfies UnifyIntentClientConfig;

export const initializeUnifyClient = (): UnifyIntentClient => {
  const globalWindow = getGlobalWindowHook();
  globalWindow.unifyClient ??= new UnifyIntentClient(UNIFY_DATA_KEY, UNIFY_CLIENT_CONFIG);

  return globalWindow.unifyClient;
};

export const getUnifyClient = (): UnifyIntentClient | null => {
  return getGlobalWindowHook().unifyClient;
};
